import { Icon } from "common/Icon";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import styles from "./RouteSplitter.scss";

export class RouteSplitter extends React.PureComponent {
  onClose = () => {
    const { closeRouteSplitter, unmountComponent } = this.props;
    closeRouteSplitter();
    unmountComponent && unmountComponent();
  };

  render() {
    const { route } = this.props;

    return (
      <div className={styles.RouteSplitter}>
        <div className={styles.controls} onClick={() => this.onClose()}>
          <Icon i="ios-arrow-back" size={24} />
          <T id="RouteSplitter.returnToPlanner" defaultMessage="Return to the Route Planner" />
        </div>
        <div className={styles.header}>
          <T id="RouteSplitter.splitRoute" defaultMessage="Split Route" />
        </div>
        <div className={styles.helpText}>
          <p>
            <T
              id="RouteSplitter.instructions"
              defaultMessage="Click anywhere on the route or elevation profile to split the route at that point."
            />
          </p>
          {route.pois && route.pois.length > 0 && (
            <div>
              <p>
                <T
                  id="RouteSplitter.poiAssociation"
                  defaultMessage="Points of Interest (POI) on the route will be associated with the closest route following the split."
                />
              </p>
              <p>
                <T
                  id="RouteSplitter.poiNear"
                  defaultMessage="POI that are near both routes will be copied to both routes."
                />
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}
